import { createApp } from "vue";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";

import App from "./App.vue";
import router from "./router";
import BootstrapVueNext from "bootstrap-vue-next";
import VueApexCharts from "vue3-apexcharts";
import { QuillEditor } from '@vueup/vue-quill'
import Vue3Prism from 'vue3-prism/lib/Vue3Prism.common.js'

import { globalHelper } from './utils/helpers'


import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import ToastComponent from 'primevue/toast';
import { useToast } from 'primevue/usetoast';
import Vue3EasyDataTable from 'vue3-easy-data-table';

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Import specific icons
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { faFacebook } from '@fortawesome/free-brands-svg-icons'
import VueGoodTablePlugin from 'vue-good-table-next';
import Swal from 'sweetalert2'
// import { VueSpinnersPlugin } from 'vue3-spinners';


import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";
import "swiper/css";
import "swiper/css/bundle";
import 'flatpickr/dist/flatpickr.css';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import '@vueup/vue-quill/dist/vue-quill.bubble.css';
import "vue3-prism/lib/Vue3Prism.css"
import 'vue3-easy-data-table/dist/style.css';
import 'vue-good-table-next/dist/vue-good-table-next.css';
import 'sweetalert2/src/sweetalert2.scss'

import 'vue-select/dist/vue-select.css';


import "./assets/custom.scss";
import { useAuthStore } from "./stores/auth";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import 'sweetalert2/dist/sweetalert2.min.css'
import PaginatorContent from "@/components/PaginatorContent.vue";

import vSelect from 'vue-select'


// Add icons to the library
library.add(faUserSecret, faFacebook)


const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp(App)
app.use(pinia);
app.use(router);
app.use(VueApexCharts);
app.use(BootstrapVueNext);
app.use(PrimeVue);
app.use(ToastService);

app.use(Toast);
app.use(VueGoodTablePlugin);
// app.use(VueSpinnersPlugin);




router.beforeEach((to, from, next) => {
  const auth = useAuthStore()
  const  userPermissions  = auth.permissions;
  // console.log("User Permissions:", userPermissions)
  // console.log("Auth Token:", auth.token)
  // console.log("Requires Auth:", to.meta.requiresAuth)

  if (to.meta.requiresAuth && !auth.token) {
    // user not connected → redirect to login
    localStorage.clear()
    // next({ name: "LoginPage", query: { redirect: to.fullPath } })
     next({ name: "LoginPage" })
  } 

  // 🔑 Check permissions if route has them
  if (Array.isArray(to.meta.permissions)) {
    // console.log("Route Permissions:", to.meta.permissions)
    // console.log(userPermissions.includes(to.meta.permissions[0]));
    const hasPermission = to.meta.permissions.every((p: string) => userPermissions.includes(p));
   console.log("Has Permission:", hasPermission);
    if (!hasPermission) {
       next({ name: "ErrorPage" }); // Or redirect to dashboard
    }
  }
  // else {
  //   // user connected OR route does not need auth
    next()
  // }
})

// Register Toast globally
app.component('Toast', ToastComponent);
app.component('QuillEditor', QuillEditor)
.use(Vue3Prism)

app.component('EasyDataTable', Vue3EasyDataTable);
app.component('font-awesome-icon', FontAwesomeIcon)
app.component("PaginatorContent",   PaginatorContent);

app.component('v-select', vSelect)
// Add global function
app.config.globalProperties.$showSuccessToast = (message: string) => {
  const toast = useToast();
  toast.add({
    severity: 'success',
    summary: 'Success',
    detail: message,
    life: 3000,
  });
};

app.config.globalProperties.$showErrorToast = (message: string) => {
  const toast = useToast();
  toast.add({
    severity: 'error',
    summary: 'Erreur',
    detail: message,
    life: 3000,
  });
};

app.config.globalProperties.$globalHelper = globalHelper

app.mount("#app");


// 🔥 Global permissions refresher
const auth = useAuthStore()

// fetch once on startup
auth.fetchPermissions()

// refresh every 60s
setInterval(() => {
  auth.fetchPermissions()
}, 60000)
